export const accounts = [
  {
    id: "3502354",
    logoId: "1",
    currency: { name: "RUB" },
    interestRate: 4,
    openedAt: "2019-10-13T18:31:42Z",
    totalSum: 2495
  },
  {
    id: "3502355",
    logoId: "2",
    currency: { name: "RUB" },
    interestRate: 5,
    openedAt: "2019-10-13T19:31:42Z",
    totalSum: 100
  },
  {
    id: "3502356",
    logoId: "1",
    currency: { name: "RUB" },
    interestRate: 8,
    openedAt: "2019-10-13T13:31:42Z",
    totalSum: -1200
  }
];
export const deposits = [
  {
    id: "2352332",
    logoId: "1",
    currency: { name: "RUB" },
    interestRate: 7,
    totalSum: 8600,
    openedAt: "2019-10-13T18:31:42Z",
    closeAt: "2020-10-13T18:31:42Z"
  },
  {
    id: "2352333",
    logoId: "2",
    currency: { name: "USD" },
    interestRate: 2,
    totalSum: 3000,
    openedAt: "2019-10-13T18:31:42Z",
    closeAt: "2022-10-13T18:31:42Z"
  }
];
export const operations = [
  {
    id: "112412",
    sum: -370,
    type: "1",
    currency: { name: "RUB" },
    accountId: "3502354",
    createdAt: "2019-10-12T17:31:42Z",
    merchant: { id: "1", name: "Макдональдс" }
  },
  {
    id: "112813",
    sum: -500,
    type: "1",
    currency: { name: "RUB" },
    accountId: "3502355",
    createdAt: "2019-10-14T18:31:42Z",
    merchant: { id: "1", name: "Макдональдс" }
  },
  {
    id: "113813",
    sum: -2512,
    type: "1",
    currency: { name: "RUB" },
    accountId: "3502354",
    createdAt: "2019-10-13T15:31:42Z",
    merchant: { id: "2", name: "Дикси" }
  },
  {
    id: "113819",
    sum: -373,
    type: "4",
    currency: { name: "RUB" },
    accountId: "3502354",
    createdAt: "2019-10-13T18:31:42Z",
    user: { id: "1", name: "Антону" }
  },
  {
    id: "114819",
    sum: 6000,
    type: "5",
    currency: { name: "RUB" },
    accountId: "3502354",
    createdAt: "2019-10-14T18:31:42Z"
  },
  {
    id: "124819",
    sum: 600,
    type: "3",
    currency: { name: "RUB" },
    accountId: "3502355",
    createdAt: "2019-10-15T12:31:42Z"
  },
  {
    id: "124820",
    sum: -250,
    type: "1",
    currency: { name: "RUB" },
    accountId: "3502354",
    createdAt: "2019-10-15T18:22:42Z",
    merchant: { id: "1", name: "Макдональдс" }
  },
  {
    id: "125819",
    sum: -1200,
    type: "1",
    currency: { name: "RUB" },
    accountId: "3502356",
    createdAt: "2019-10-13T13:01:42Z",
    merchant: { id: "2", name: "Дикси" }
  },
  {
    id: "133820",
    sum: 2000,
    type: "5",
    currency: { name: "RUB" },
    accountId: "2352332",
    createdAt: "2019-10-12T18:31:42Z"
  },
  {
    id: "133822",
    sum: 2000,
    type: "5",
    currency: { name: "USD" },
    accountId: "2352333",
    createdAt: "2019-10-12T18:31:42Z"
  },
  {
    id: "133823",
    sum: 3000,
    type: "5",
    currency: { name: "USD" },
    accountId: "2352332",
    createdAt: "2019-10-13T12:31:42Z"
  },
  {
    id: "133824",
    sum: 900,
    type: "5",
    currency: { name: "USD" },
    accountId: "2352333",
    createdAt: "2019-10-13T12:31:42Z"
  },
  {
    id: "133825",
    sum: 100,
    type: "3",
    currency: { name: "USD" },
    accountId: "2352333",
    createdAt: "2019-10-13T12:31:42Z"
  },
  {
    id: "133826",
    sum: 600,
    type: "3",
    currency: { name: "RUB" },
    accountId: "2352332",
    createdAt: "2019-10-13T12:31:42Z"
  },
  {
    id: "163826",
    sum: 1000,
    type: "5",
    currency: { name: "USD" },
    accountId: "2352332",
    createdAt: "2019-10-13T12:31:42Z"
  },
];
export const users = {
  "0": { id: "0", name: "Поддержка" },
  "1": { id: "1", name: "Иван" }
};
export const supportUserId = "0";
export const stickers = [
  { id: "1" },
  { id: "2" },
  { id: "3" },
  { id: "4" },
  { id: "5" },
  { id: "6" },
  { id: "7" },
  { id: "8" },
  { id: "9" },
  { id: "10" },
  { id: "11" },
  { id: "12" },
  { id: "13" },
  { id: "14" },
  { id: "15" },
  { id: "16" },
  { id: "17" },
  { id: "18" },
  { id: "19" },
  { id: "20" },
  { id: "21" },
  { id: "22" },
  { id: "23" },
  { id: "24" }
];